import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/LoginPage";

/**
 * @name CaptureFirstLoginMFAForm
 * @returns {React.Component}
 * @description Captue component to show the login page with the user id and
 * password fields filled. With the first time login modal opened
 */
export default function CaptureFirstLoginMFAForm(props) {
    // Initalize a new BCMSStateManagerCRUD using the default page data
    // setting the user id and password properties
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "userID" ], "DemoUser")
        .update([ "password" ], "123456789012")
        .submit();

    // initalize a new BCMSStateManagerCRUD instance using the default page ui
    // updating the modal property
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "modal", "id" ], "FirstTimeLoginModal")
        .submit();

    // Return the login page passing the data and ui variables
    return <LoginPage data={ data } ui={ ui } />
}